
import React, { useEffect, useState } from 'react';
import {
  TextField, Select, MenuItem, Grid,
  FormControl,
  InputLabel,
  Box,
  FormHelperText,
  Tooltip,
  IconButton
} from '@mui/material';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


import {  convertToLabel, isObjectAndNotEmpty } from './utils';
import { useSelector } from 'react-redux';

const UNITS = [
  'DAYS',
  'MONTHS',
  'QUARTERS'
]

const UNIT = [
  'DAY',
  'MONTH',
  'QUARTER'
]


const RenderDynamicDateBasedOnOperator = ({type, handleBlur = () => {}, intialValue, operation, disabled, entityAttribute}) => {
  //console.log("entityAttribute", entityAttribute);
  const checkEmptyAndGetValue =() => {
    if (isObjectAndNotEmpty(intialValue)){
      return intialValue;
    } else {
      return {
        dateUnit: '',
        startValue: 0,
        endValue: 0,
        fromInputDate: '',
        toInputDate: '',
        givenDate: ''
      }
    }
  }

  const [date, setDate] = useState(checkEmptyAndGetValue());

  useEffect(() => {
    setDate(checkEmptyAndGetValue());
  }, [operation])

  const DATE_ATTR = {
    DATE_UNIT: 'dateUnit',
    START_VALUE: 'startValue',
    END_VALUE: 'endValue',
    FROM_INPUT_DATE: 'fromInputDate',
    TO_INPUT_DATE: 'toInputDate',
    GIVEN_DATE: 'givenDate'
  };

  const handleDateChange = ({attr, value}) => {
    const newValue = {...date}
    newValue[attr] = value;
    if(attr === DATE_ATTR.FROM_INPUT_DATE){
      newValue[DATE_ATTR.TO_INPUT_DATE] = '';
    }
    setDate(newValue);
    handleBlur(newValue);
  };
  const emptyToDate = ({attr, value}) => {
    const newValue = {...date}
    newValue[attr] = value;
    setDate(newValue);
  };

  const handleChange = ({attr, value}) => {
    const newValue = {...date}
    newValue[attr] = value;
    if(attr === DATE_ATTR.START_VALUE){
      newValue[DATE_ATTR.END_VALUE]=0;
    }
    setDate(newValue);
    handleBlur(newValue);
  };

  const handleDateBlur = ({attr, value}) => {
    const newValue = {...date}
    newValue[attr] = value;
    handleBlur(newValue);
  };

  const getIsFromDisabled = () => {
    return (operation === 'WITHIN_NEXT' || operation === 'NOT_WITHIN_NEXT');
  };

  const getIsToDisabled = () => {
    return (operation === 'WITHIN_PAST' || operation === 'NOT_WITHIN_PAST');
  }

  let minToDate = new Date(Date.parse(date.fromInputDate));
  minToDate.setDate(minToDate.getDate() + 1);
  const maxDate = entityAttribute === 'registration_device_date' || entityAttribute === 'registration_date' ? new Date() : null;
  switch (type) {
    case '2-dates':
      return (
        <>
          <Grid item xs={3}>
            <DatePicker
              label={<Box color={'#000'} >Start Date</Box>}
              value={Date.parse(date.fromInputDate)}
              onChange={(date) => {
                handleDateChange({attr: DATE_ATTR.FROM_INPUT_DATE, value: date});
              }}
              renderInput={(params) => <TextField {...params} />}
              disabled={disabled}
              maxDate={Date.parse(maxDate)}
            />
          </Grid>
          <Grid item xs={3}>
            <DatePicker
              label={<Box color={'#000'} >End Date</Box>}
              value={Date.parse(date.toInputDate)}
              onChange={(date) => handleDateChange({attr: DATE_ATTR.TO_INPUT_DATE, value : date})}
              renderInput={(params) => <TextField {...params} />}
              disabled={disabled}
              minDate={Date.parse(minToDate)}
              maxDate={Date.parse(maxDate)}
            />
          </Grid>
        </>
        
      );
    case 'date':
      return (
        <Grid item xs={3}>
          <DatePicker
            label={<Box color={'#000'} >Date</Box>}
            value={Date.parse(date.givenDate)}
            onChange={(date) => handleDateChange({attr: DATE_ATTR.GIVEN_DATE, value : date})}
            renderInput={(params) => <TextField {...params} />}
            disabled={disabled}
            maxDate={Date.parse(maxDate)}
          />
        </Grid>
      );
    case '2-input-1-dropdown':
      return (
        <>
          <Grid item xs={2}>
            <FormControl disabled={disabled}>
              <InputLabel className='dynamicFieldLabel' shrink>{'From'}</InputLabel>
              <TextField
                // label='From'
                type="number"
                value={date.startValue}
                onChange={(e) => handleChange({attr: DATE_ATTR.START_VALUE, value: e.target.value})}
                disabled={getIsFromDisabled()}
                // onBlur={(e) => handleDateBlur({attr: DATE_ATTR.START_VALUE, value: e.target.value})}
              />
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <FormControl disabled={disabled}>
              <InputLabel className='dynamicFieldLabel' shrink>{'To'}</InputLabel>
              <TextField
                // label='To'
                type="number"
                value={date.endValue}
                onChange={(e) => handleChange({attr: DATE_ATTR.END_VALUE, value: e.target.value})}
                // onBlur={(e) => handleDateBlur({attr: DATE_ATTR.END_VALUE, value: e.target.value})}
                disabled={getIsToDisabled()}
                
              />
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <FormControl fullWidth disabled={disabled}>
              <InputLabel id="dynamicUnitSelectLabel"  className='dynamicFieldLabel' shrink>{'Unit'}</InputLabel>
              <Select 
                labelId='dynamicUnitSelectLabel'
                value={date.dateUnit} 
                onChange={(e) => handleChange({attr: DATE_ATTR.DATE_UNIT, value: e.target.value})}
                // onBlur={(e) => handleDateBlur({attr: DATE_ATTR.DATE_UNIT, value: e.target.value})}
              >
                {UNITS.map((unit) => (
                  <MenuItem key={unit} value={unit}>{convertToLabel(unit)}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </>
      );
    case '2-number':
      return (
        <Grid container item xs={6} spacing={2} >
          <Grid item xs={6}>
            <FormControl fullWidth disabled={disabled}>
              <InputLabel className='dynamicFieldLabel' shrink>{'From'}</InputLabel>
              <TextField
                // label='From'
                type="number"
                value={Number(date.startValue)}
                onChange={(e) => {
                  if (e.target.value < 0) {
                    return
                  }
                  handleChange({attr: DATE_ATTR.START_VALUE, value: Number(e.target.value)});
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} disabled={disabled}>
            <FormControl fullWidth>
              <InputLabel className='dynamicFieldLabel' shrink>{'To'}</InputLabel>
              <TextField
                // label='To'
                type="number"
                value={Number(date.endValue)}
                onBlur={(e) => {
                  setTimeout(()=>{
                    if ((e.target.value < 0 || e.target.value<(Number(date.startValue)+1)) && (e.target.value!=='' && e.target.value!=='0')) {
                      handleChange({attr: DATE_ATTR.END_VALUE, value: 0});
                      return
                    }
                    handleChange({attr: DATE_ATTR.END_VALUE, value: Number(e.target.value)});
                  },100);
                  
                }}
                onChange={(e)=>{
                  handleChange({attr: DATE_ATTR.END_VALUE, value: Number(e.target.value)});
                }}
                inputProps={{ min: (Number(date.startValue)+1), max: 1000 }}
              />
            </FormControl>
          </Grid>
          {/* {((date.startValue > 0) && (date.startValue >= date.endValue)) && (
              <Grid item xs={12}>
                <FormHelperText style={{color: 'red'}}>
                  Start value should be less than the end value
                </FormHelperText>
              </Grid>
          )} */}
        </Grid>
      );
      case 'range_select': 
        return(
          <>
            <Grid item xs={2}>
              <FormControl fullWidth disabled={disabled}>
                <Select 
                  value={date.dateUnit} 
                  onChange={(e) => handleChange({attr: DATE_ATTR.DATE_UNIT, value: e.target.value})}
                  // onBlur={(e) => handleDateBlur({attr: DATE_ATTR.DATE_UNIT, value: e.target.value})}
                >
                  <MenuItem value="" disabled>Select Option</MenuItem>
                  {UNIT.map((unit) => (
                    <MenuItem key={unit} value={unit}>{convertToLabel(unit)}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </>
        )
      default:
      return null;
  }
};


export const RenderDynamicField = ({ type = 'text', intialValue = "", handleBlur, values, label = 'Attribute Value Is:', id, disabled = false, addGrid = false, attributeType, operation, clearDependentValues, entityAttribute, validationError = false}) => {
  let addAGrid = addGrid;
  let field = null;
  //console.log("entityAttribute", entityAttribute);
  // const [value, setValue] = useState("");

  // useEffect(() => {
  //   setValue(intialValue)
  // }, [intialValue])


  const generateOptions = (options) => {
    let optionsToReturn = [...options];
    if (!options.length && (attributeType === 'boolean' || operation === 'is_null' || operation === 'is_not_null')) {
      optionsToReturn = ['True', 'False']
    }
    return(
      optionsToReturn?.map((option, index) => {
        let value = "";
        let label = "";
        if(typeof option === 'string'){
            value = option;
            label = option;
        } else {
            value = option.value;
            label = option.label;
        }
        return(
          <MenuItem key={index} value={value}>
            {convertToLabel(label)}
          </MenuItem>
        )
      })
    )
  };

  const handleChange = (e) => {
    e.preventDefault();
    // setValue(e.target.value);
    handleBlur(e.target.value)
  }

  switch (type) {
    case 'number':
      field = (
        <FormControl fullWidth key={id} disabled={disabled}>
            <InputLabel labelId="dynamicNumberLabel"  className='dynamicFieldLabel' shrink>{label}</InputLabel>
            <TextField
                id='dynamicNumberLabel'
                type="number"
                value={intialValue}
                onChange={(e) => {
                  if (e.target.value < 0) {
                    e.target.value=0;
                    return false;
                  }
                  handleChange(e);
                }}
                // onBlur={(e) => handleBlur(e.target.value)}
                fullWidth
                slotProps={{
                  input: {
                    min: 1,
                    max: 100,
                  },
                }}
            />
        </FormControl>
       
      );
      break;
    case 'select':
      field = (
        <FormControl fullWidth key={id} disabled={disabled}>
            <InputLabel id="dynamicSelectLabel"  className='dynamicFieldLabel' shrink>{label}</InputLabel>
            <Select
                labelId="dynamicSelectLabel"
                id="dynamicSelect"
                value={intialValue}
                label={label}
                placeholder={label}
                onChange={(e) => handleChange(e)}
                 sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: validationError ? 'red' : undefined,
              },
            }}
            >
              <MenuItem value="" disabled={true}>Select Option</MenuItem>
               {generateOptions(values)}
            </Select>
        </FormControl>
      );
      break;
    case 'multi-select':
      field = (
        <FormControl fullWidth key={id} disabled={disabled}>
            <InputLabel id="dynamicMultiSelectLabel"  className='dynamicFieldLabel' shrink>{label}</InputLabel>
            <Select
                labelId='dynamicMultiSelectLabel'
                id='dynamicMultiSelect'
                multiple
                value={(typeof intialValue === 'string' ? intialValue?.split(',') : intialValue) || []}
                onChange={(e) => handleChange(e)}
                fullWidth
            >   
              <MenuItem value="" disabled>Select Option</MenuItem>
              {generateOptions(values)}
            </Select>
        </FormControl>
       
      );
      break;
    case 'date':
    case '2-dates' :
    case '2-input-1-dropdown':
    case 'range_select':
    case '2-number':
      addAGrid = false;
      field = RenderDynamicDateBasedOnOperator({type, handleBlur, intialValue, operation, disabled, entityAttribute})
      break;
    case 'text':
      field = (
        <FormControl fullWidth key={id}>
            <InputLabel id="dynamicTextLabel" className='dynamicFieldLabel' shrink>{label}</InputLabel>
            <TextField
                // label={label}
                id='dynamicTextLabel'
                disabled={disabled}
                type="text"
                value={intialValue}
                onChange={(e) => handleChange(e)}
                // onBlur={(e) => handleBlur(e.target.value)}
                fullWidth

            />
        </FormControl>
      );
      break;
  }

  if (addAGrid) {
    return (
      <Grid item xs={3}>
        {field}
      </Grid>
    )
  } else {
    return field;
  }
};

export const RenderAggregatorField = ({ value, handleChange, rules = [], disabled, id}) => {
  const { navigation } = useSelector((state) => state);
  const { groupDetails } = navigation;
  const [aggregatorState, setAggregatorState] = useState(value);

  useEffect(() => {
    setAggregatorState(value);
  }, [value])



  //const options = ['first', 'exactly', 'greater', 'lesser', 'atleast', 'utmost']; // keeping only the order by and removing rest options
  const options = ['first'];
  const orderOptions = ['asc', 'desc'];

  const FIELDS = {
    AGGREGATOR: 'countOperation',
    ON: 'orderAttributeName',
    ORDER_BY: 'orderBy',
    NUMERIC: 'countValue'
  }

  const handleAggregatorChange = (value, field) => {
    const newAggregatorState = {...aggregatorState};
    if (aggregatorState.countOperation === 'first' || aggregatorState.countOperation === 'last') {
      newAggregatorState.countValue = '';
    } else {
      newAggregatorState.orderAttributeName = '';
      newAggregatorState.orderBy = '';
    }
    newAggregatorState[field] = value;
    setAggregatorState(newAggregatorState);
    handleChange(newAggregatorState);
  };

  const getAllOrderAttributeNamesWithIds = (groups) => {
    const result = [];

    const recurse = (items) => {
      items.forEach((item) => {
        const orderAttr = item?.aggregator?.orderAttributeName;
        if (orderAttr && orderAttr.trim() !== "") {
          result.push({
            id: item.id,
            orderAttributeName: orderAttr
          });
        }
        if (Array.isArray(item.groups) && item.groups.length > 0) {
          recurse(item.groups);
        }
      });
    };

    recurse(groups);
    return result;
  };

  const comboExists = (list, id, orderAttributeName) =>
  list.some(
    item => item.id === id && item.orderAttributeName === orderAttributeName
  );
  const orderAttributeNameNotExists = (list, orderAttributeName) => !list.some(item => item.orderAttributeName === orderAttributeName);
  // Example usage:
  const orderAttributes = getAllOrderAttributeNamesWithIds(groupDetails);

  

  const getOptions = (selectedOrderAttributeName) => {
    if (!rules.length) {
      return [];
    };

    let options = rules?.map(rule => {
      //console.log("rule", rule);
      if(orderAttributeNameNotExists(orderAttributes, rule.entityAttribute) || comboExists(orderAttributes, id, rule.entityAttribute)){
        return rule.entityAttribute;
      }
    }).filter(Boolean);
    if (selectedOrderAttributeName && !options.includes(selectedOrderAttributeName) && options.length<1) {
      options.push(selectedOrderAttributeName);
    }
    return options;
  }

  return (
    <>
      <Grid item xs={3}>
        <FormControl fullWidth disabled={disabled}>
          <InputLabel id="aggregator"  style={{color: '#000', backgroundColor:'#fff'}} shrink>{'Aggregator'}</InputLabel>
          <Select
            labelId='aggregator'
            value={aggregatorState.countOperation}
            onChange={(e) => handleAggregatorChange(e.target.value, FIELDS.AGGREGATOR)}
            variant="outlined"
          >
            <MenuItem value="" disabled>Select Option</MenuItem>
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option === 'first' ? "Order By" : convertToLabel(option)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      {aggregatorState.countOperation === 'first' || aggregatorState.countOperation === 'last' ? (
        <>
          <Grid item xs={3}>
            <FormControl fullWidth disabled={disabled}>
              <InputLabel id="on"  style={{color: '#000', backgroundColor:'#fff'}} shrink>{'On '} 
                <Tooltip title="Aggregator for entity and entity attributes combination, can be selected once.">
                <IconButton size="small" style={{ padding: 0 }}>
                  <InfoOutlinedIcon fontSize="small" color="action" />
                </IconButton>
              </Tooltip>
              </InputLabel>
              
              <Select
                value={aggregatorState.orderAttributeName}
                onChange={(e) => handleAggregatorChange(e.target.value, FIELDS.ON)}
                variant="outlined"
                labelId="On"
              >
                <MenuItem value="" disabled>Select Option</MenuItem>
                  {getOptions(aggregatorState.orderAttributeName)?.map((option) => (
                    <MenuItem key={option} value={option}>
                      {convertToLabel(option)}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth disabled={disabled}>
              <InputLabel id="order"  style={{color: '#000', backgroundColor:'#fff'}} shrink>{'Order'}</InputLabel>
              <Select
                labelId='order'
                value={aggregatorState.orderBy}
                onChange={(e) => handleAggregatorChange(e.target.value, FIELDS.ORDER_BY)}
                variant="outlined"
              >
                <MenuItem value="" disabled>Select Option</MenuItem>
                  {orderOptions?.map((option) => (
                    <MenuItem key={option} value={option}>
                      {convertToLabel(option)}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </>
      ) : (
        <Grid item xs={3}>
          <FormControl>
            <InputLabel style={{color: '#000', backgroundColor:'#fff'}} shrink>{'Enter Value'}</InputLabel>
            <TextField 
              variant="outlined" 
              placeholder="Enter Value" 
              type="number" 
              value={aggregatorState.countValue}
              onChange={(e) => {
                if (e.target.value < 0) {
                  return
                }
                handleAggregatorChange(e.target.value, FIELDS.NUMERIC);
              }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      )}
    </>
  );

}